import { Command } from '@/plugins/cad/module/core/Command'
import type { CADViewManager } from '../manager/CADViewManager'
import type { IEntity } from '../model/entity'

/**
 * 偏移实体命令，每次偏移会新增一个实体，支持整体撤销/重做。
 */
export class OffsetEntityCommand extends Command {
  /** 每次偏移生成的实体，按操作顺序存储（支持多次连续偏移） */
  private createdEntities: IEntity[] = []

  constructor(private viewManager: CADViewManager) {
    super()
  }

  /** 占位（实际执行在 addEntity 中） */
  execute(): void {}

  /** 撤销：移除本次命令生成的全部偏移实体 */
  undo(): void {
    this.viewManager.deleteEntities(this.createdEntities)
  }

  /** 重做：重新加入本次命令生成的偏移实体 */
  redo(): void {
    this.viewManager.addEntities(this.createdEntities)
  }

  /**
   * 是否允许提交命令。
   *
   * @returns 生成过至少一个偏移实体时返回 true
   */
  canCommit(): boolean {
    return this.createdEntities.length > 0
  }

  /**
   * 追加一个偏移生成的实体并立即加入视图。
   *
   * @param entity - 新增的偏移实体
   */
  addEntity(entity: IEntity) {
    this.createdEntities.push(entity)
    this.viewManager.addEntities([entity])
  }
}
